























































import { Component, Emit, Model, Prop, Watch } from 'vue-property-decorator';
import { ViewpointApi, VIEWPOINT_API } from '@/api/ViewpointApi';
import Apps from '@/store/modules/Apps';
import Vue from 'vue';
import { getModule } from 'vuex-module-decorators';
import Decisions from '@/store/modules/Decisions';
import { AppModel } from '@/api/model/AppModel';
import TemplateLaunchDialog from '@/components/apps/TemplateLaunchDialog.vue';
import LoginRegisterDialog from '@/views/Auth/LoginRegisterDialog.vue';
import { BILLINGS as billingsDao } from "@/api/BillingsDao";
import _ from 'lodash';
import { Urls } from '@/Urls';
import { Auth } from 'aws-amplify';
import LaunchAppLoadingDialog from '@/components/apps/LaunchAppLoadingDialog.vue';

const appsModule = getModule(Apps);
const decisionsModule = getModule(Decisions);
@Component({
    components: { TemplateLaunchDialog, LoginRegisterDialog, LaunchAppLoadingDialog },
})
export default class TemplateSubscribeButton extends Vue {
    private dialog = false;

    @Prop({ default: '', type: String })
    selectedDecisionTemplateId!: string;

    @Prop({
        default: () => {
            return {};
        },
        type: Object,
    })
    selectedDecisionTemplateProp!: any;

    @Prop()
    currentUserId!: string;

    private loading = false;
    private products: any = null;
    private loadingDialog = false;

    get decisionId() {
        return decisionsModule.selectedDecisionId;
    }

    get isOwner() {
        if (this.selectedDecisionTemplateProp != null) {
            return this.selectedDecisionTemplateProp?.ownerUserId
                ? this.currentUserId != undefined && this.currentUserId === this.selectedDecisionTemplateProp.ownerUserId
                : false;
        } else return false;
    }

    get isSubscribed() {
        // console.log(this.selectedDecisionTemplateProp);
        if (this.selectedDecisionTemplateProp != null) {
            return this.selectedDecisionTemplateProp?.userIds
                ? this.currentUserId != undefined && this.currentUserId in this.selectedDecisionTemplateProp.userIds
                : false;
        } else return false;
    }

    get decisionTemplatesDict() {
        return appsModule.decisionTemplatesDict;
    }

    get decisionTemplateDetailsDict() {
        return appsModule.decisionTemplateDetailsDictionary;
    }

    get isDevEnv() {
        return (process.env.VUE_APP_API_CORE_ENDPOINT === 'https://beta-api.viewpoint-ai.com')
    }

    get decisionDetail() {
        if (this.decisionTemplateDetailsDict && this.selectedDecisionTemplateProp.decisionIdRef) {
            return this.decisionTemplateDetailsDict[
                this.selectedDecisionTemplateProp.decisionIdRef
            ];
        } else {
            return null;
        }
    }

    private async subscribeTemplate() {
        console.log(this.currentUserId, this.selectedDecisionTemplateProp)
        if (this.currentUserId && this.selectedDecisionTemplateProp) {
            this.selectedDecisionTemplateProp.subscriptionStatus = true;
        
            if(this.selectedDecisionTemplateProp && this.selectedDecisionTemplateProp.stripeProductCode) {
                Vue.$cookies.set('app-subscribe', this.selectedDecisionTemplateProp.id)
                await this.select(this.selectedDecisionTemplateProp.stripeProductCode)
            } else {
                this.selectedDecisionTemplateProp.subscriptionStatus = true;
                await appsModule.addUserToApp({
                    id: this.selectedDecisionTemplateProp.id,
                    userId: this.currentUserId,
                });
            }
        } else { 
            if (this.selectedDecisionTemplateProp && this.selectedDecisionTemplateProp.stripeProductCode) {
                Vue.$cookies.set('app-subscribe', this.selectedDecisionTemplateProp.stripeProductCode);
            } else {
                Vue.$cookies.set('app-add', this.selectedDecisionTemplateProp.id);
            }
            this.dialog = true;
        }
        
    }

    private async unsubscribeTemplate() {
        if([undefined, null].includes(this.currentUserId) || !this.selectedDecisionTemplateProp) {
            return;
        }
        this.selectedDecisionTemplateProp.subscriptionStatus = false;
        if(this.selectedDecisionTemplateProp.stripeProductCode) {
            await billingsDao.unsubscribeToProduct(this.selectedDecisionTemplateProp.decisionIdRef)
        }
        await appsModule.removeUserFromApp({
            id: this.selectedDecisionTemplateProp.id,
            userId: this.currentUserId,
        });
    }

    private async launchIntoNewDecision(event) {
        this.loading = true;
        if (!this.selectedDecisionTemplateProp) return;
        try {
            this.loadingDialog = true;
            await decisionsModule.copyTemplateIntoNewDecision({
                decision: this.selectedDecisionTemplateProp,
                newTemplateDecisionId: this.selectedDecisionTemplateId,
                newDecisionName: event.newDecisionName,
                options: {
                    includeChoices: event.options.includeChoices,
                    includeViewpoints: event.options.includeViewpoints,
                    includeApps: event.options.includeApps,
                    includeLists: event.options.includeLists,
                    includeUsers: event.options.includeUsers
                }
            });
            // await decisionsModule.copyIntoNewDecision(this.decisionDetail)
        } catch (err) {
            console.log(err);
            this.loadingDialog = false;
        }
        this.loading = false;
        this.loadingDialog = false;
    }

     private select(itemId: string) {
        let location: any = {
            path: Urls.CHECKOUT,
            query: {
                product: itemId,
                successUrl: window.location.origin + Urls.TEMPLATES + '?session_id={CHECKOUT_SESSION_ID}',
                cancelUrl: window.location.origin + Urls.TEMPLATES
            }
        }
        
        this.$router.push(location);
    }
}
